import React from 'react';
import PropTypes from 'prop-types';

import Media from '../../media';
import { Link } from '../../../atoms/link/Link';

import { columnPosition, gridColumnCount } from './_vars';
import { formatUrl } from '../utils';
import styles from './JournalTeaser.module.scss';
import { useWindowSize } from 'react-use';

const JournalTeaser = ({ media, position = 1, url, isSSR, articlesCount }) => {
  if (isSSR) return null;
  const { width } = useWindowSize();
  const columnCount = gridColumnCount(width);
  const pos = articlesCount < position ? articlesCount + 1 : position;
  const rowPosition = pos <= columnCount ? 1 : Math.ceil(pos / columnCount);

  const linkUrl = typeof url === 'object' ? { reference: url } : formatUrl(url);

  return (
    <div
      className={styles.container}
      style={{
        '--teaser-original-position': pos,
        '--teaser-column-position': columnPosition(pos, width),
        '--teaser-row-position': rowPosition,
      }}
    >
      <Link className={styles.mediaBlock} link={linkUrl}>
        <Media media={media} isSSR={isSSR} />
      </Link>
    </div>
  );
};

JournalTeaser.propTypes = {
  media: PropTypes.object.isRequired,
  position: PropTypes.number,
  articlesCount: PropTypes.number,
  url: PropTypes.string,
  isSSR: PropTypes.bool,
};

export default JournalTeaser;
